import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

const MSG = {
  membership: "Your membership is active — you're in line.",
  extra: "Added to your trip upgrade fund.",
  buy_now: "Your trip is booked! We'll be in touch to plan dates.",
};

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [kind, setKind] = useState(null);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let stop = false;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (stop) return;
        setKind(data.kind);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch { /* retry */ }
      if (++tries >= 15) return setState("timeout");
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId, cancelled]);

  const view = {
    checking: [Loader2, "Confirming your payment…", "This only takes a moment.", "animate-spin text-[#38BDF8]"],
    paid: [CheckCircle2, "Payment confirmed", MSG[kind] || "Thank you!", "text-emerald-400"],
    failed: [XCircle, "Payment didn't go through", "No charge was made. You can try again from your dashboard.", "text-red-400"],
    cancelled: [XCircle, "Checkout cancelled", "No charge was made.", "text-slate-400"],
    timeout: [Loader2, "Still processing", "Your payment is taking longer than usual — check your dashboard shortly.", "text-[#38BDF8]"],
  }[state];
  const [Icon, title, text, cls] = view;

  return (
    <div className="min-h-screen grid place-items-center px-5 pt-24">
      <div data-testid="payment-result" className="lux-card p-10 max-w-md w-full text-center">
        <Icon className={`w-12 h-12 mx-auto ${cls}`} />
        <h1 data-testid="payment-result-title" className="font-serif-lux text-4xl mt-6">{title}</h1>
        <p className="text-slate-400 mt-3">{text}</p>
        <Link to="/dashboard" data-testid="payment-result-dashboard-btn" className="btn-gold inline-block px-6 py-3 mt-8">Go to my dashboard</Link>
      </div>
    </div>
  );
}
